import axios, { InternalAxiosRequestConfig } from 'axios';
import { AuthEnum } from '../enum/auth.enum';
import { Auth } from '../models/auth.model';
import { useNotificationService } from '../services/notification.service';
import { clear, getLocalStorageItem } from '../util/store';
import {  IUnidadeCleanDTO } from '../models/happy-code-api.model';
import i18n from '../i18n';

const http = axios.create({
  baseURL: process.env.REACT_APP_HAPPYCODE_PUBLIC_BASE_URL_API,
});

const token = () => {
  const auth = getLocalStorageItem(AuthEnum.TOKEN_KEY) as Auth;
  return auth?.access_token;
};


const tipoUnidadeIdFranquia = () => {
	const tipoUnidade = getLocalStorageItem("@HappyCodeAcademy/login/unidade") as IUnidadeCleanDTO;
	return tipoUnidade?.unidadeTipoUnidadeCodigo;
}

const tipoUnidadeIdSede = () => {
	const unidade = getLocalStorageItem("@HappyCodeAcademy/login/unidade") as IUnidadeCleanDTO;
	return unidade?.unidadeTipoUnidadeCodigo;
}


const defaultErrorMessage = i18n.t("global_errors:errors.defaultErrorMessage", {code: "[2]"});

http.interceptors.request.use(
  (request: InternalAxiosRequestConfig<any>) => {
    if (!request.headers['Authorization'])
      request.headers['Authorization'] = `Bearer ${token()}`;

    if (!request.headers['Content-Type'])
      request.headers['Content-Type'] = 'application/json';

    if (!request.headers['Accept'])
      request.headers['Accept'] = 'application/json';

		if (!request.headers['x-tipo-unidade-ds'] && tipoUnidadeIdFranquia() != null){
			request.headers['x-tipo-unidade-ds'] = tipoUnidadeIdFranquia();
		}

		if (!request.headers['x-tipo-unidade-ds'] && tipoUnidadeIdSede() != null){
			request.headers['x-tipo-unidade-ds'] = tipoUnidadeIdSede();
		}
		
    return request;
  },
  (error) => Promise.reject(error),
);

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response) {
      const { status } = error.response;
      const notification = useNotificationService();

      switch (status) {
        case 401: {
          if (error.config.headers['MensagemPersonalizada']) {
            notification({
              description: error.config.headers['MensagemPersonalizada'],
              type: 'info',
              message: i18n.t("common:message"),
            });
          } else {
            notification({
              description: i18n.t('global_errors:errors.unauthorized'),
							type: 'warning',
					  	message: i18n.t('global_errors:errors.unauthorizedMessage')
            });
          }
          const path = window.location.pathname;

          if (path !== '/login') window.location.href = '/login';

          clear();
          break;
        }
        case 404:
          notification({
            description: i18n.t(`global_errors:errors.${(error.response.data?.code || '' ).toLowerCase()}`, {defaultValue: error.response?.data?.message || defaultErrorMessage}),
            type: 'warning',
            message: i18n.t('common:warning'),
          });
          break;
        case 400:
          if (error.response.data.error_description === 'Bad credentials') {
            notification({
              description: i18n.t('global_errors:errors.unauthorized'),
              type: 'warning',
              message: i18n.t('global_errors:errors.unauthorizedMessage'),
            });
            break;
          }
          notification({
            description: i18n.t(`global_errors:errors.${(error.response.data?.code || '' ).toLowerCase()}`, {defaultValue: error.response?.data?.message || defaultErrorMessage}),
            type: 'error',
            message: i18n.t('common:caution'),
          });
          break;

        default:
          notification({
  					description: i18n.t(`global_errors:errors.${(error.response.data?.code || '' ).toLowerCase()}`, {defaultValue: error.response?.data?.message || defaultErrorMessage}),
            type: 'error',
            message: i18n.t('common:caution'),
          });
          break;
      }
    }
    return Promise.reject(error);
  },
);

export default http;
